import { useState, useRef } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FestSection from './components/FestSection';
import ServicesSection from './components/ServicesSection';
import AboutSection from './components/AboutSection';
import CallToActionSection from './components/CallToActionSection';
import RadioSection from './components/RadioSection';
import VideoSection from './components/VideoSection';
import PendriveSection from './components/PendriveSection';
import TestimonialsSection from './components/TestimonialsSection';
import CoverageSection from './components/CoverageSection';
import ContactSection from './components/ContactSection';
import GallerySection from './components/GallerySection';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

export default function HomePage() {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement>(null);

  const toggleRadio = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5547984883371?text=Olá! Gostaria de solicitar um orçamento para meu evento.', '_blank');
  };

  return (
    <div className="min-h-screen bg-black">
      <audio ref={audioRef} preload="none">
        <source src="http://stm19.voxhd.com.br:7854/stream" type="audio/mpeg" />
        Seu navegador não suporta o elemento de áudio.
      </audio>
      
      <Header 
        onWhatsAppClick={handleWhatsAppClick}
        onPlayRadio={toggleRadio}
        isPlaying={isPlaying}
      />
      <HeroSection 
        onPlayRadio={toggleRadio} 
        isPlaying={isPlaying}
        onWhatsAppClick={handleWhatsAppClick}
      />
      <FestSection onWhatsAppClick={handleWhatsAppClick} />
      <ServicesSection onWhatsAppClick={handleWhatsAppClick} />
      <AboutSection onWhatsAppClick={handleWhatsAppClick} />
      <CallToActionSection onWhatsAppClick={handleWhatsAppClick} />
      <RadioSection />
      <VideoSection />
      <PendriveSection onWhatsAppClick={handleWhatsAppClick} />
      <TestimonialsSection />
      <CoverageSection onWhatsAppClick={handleWhatsAppClick} />
      <ContactSection onWhatsAppClick={handleWhatsAppClick} />
      <GallerySection onWhatsAppClick={handleWhatsAppClick} />
      <Footer />
      <WhatsAppButton onWhatsAppClick={handleWhatsAppClick} />
    </div>
  );
}